import React from "react";

const LoadingExcelBtn = () => {
  return (
    <div className="loading-in-modal-button excel">
      <div className="lds-dual-ring"></div>
    </div>
  );
};

export default LoadingExcelBtn;
